import {
  Button,
  Icon,
  InfoCircleHollowSVG,
  TooltipDialog,
} from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";
import { toolTipCss, toolTipWrapperCss } from "./VocabToolTipDialog.style";

const TooltipDialogWithTrackEvent = withTrackEvent(TooltipDialog);

const propTypes = {
  assignmentId: PropTypes.string,
  currentContentLevelId: PropTypes.string,
};

const TOOLTIP_HEADER_COPY =
  "Look for subject-specific vocabulary supports underlined throughout the text.";

const TOOLTIP_BODY_COPY =
  "These words & their definitions were generated by an AI model, but the ideas and underlying gist are original and generated by a human author.";

const VocabToolTipDialog = ({ assignmentId, currentContentLevelId }) => {
  return (
    <TooltipDialogWithTrackEvent
      __cssFor={toolTipCss}
      ariaProps={{ "aria-label": TOOLTIP_HEADER_COPY }}
      body={<div css={toolTipWrapperCss}>{TOOLTIP_BODY_COPY}</div>}
      header={TOOLTIP_HEADER_COPY}
      buttonContents={
        <Icon
          ariaProps={{ "aria-hidden": false }}
          isDecorative={false}
          size={Icon.sizes.md}
          SvgComponent={InfoCircleHollowSVG}
          title="More information on AI-generated vocabulary."
        />
      }
      buttonProps={{ flavor: Button.flavors.incognito }}
      dataProps={{
        "data-qa-selector": "ai-generated-vocab-tool-tip-dialog",
      }}
      dialogAriaProps={{
        "aria-label": "More information on AI-generated vocabulary",
      }}
      placement="top"
      fallbackPlacements={["top-left"]}
      // tracking props
      objectType="Assignment"
      actionPrefix="Initiate"
      actionName="Interact"
      streamProperties={{
        content_id: currentContentLevelId,
        content_type: "Article",
        description: "Open AI-generated vocabulary tooltip",
        objectId: assignmentId,
      }}
    />
  );
};

VocabToolTipDialog.propTypes = propTypes;

export default VocabToolTipDialog;
